import * as React from 'react'

import { Spinner } from './elements'

const Loading = () => <Spinner className="loading" />

export default Loading



// WEBPACK FOOTER //
// ./src/components/Overlays/Loading/index.tsx